import { func, object, shape, string } from 'prop-types';

export var routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

export var locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});


//////////////////
// WEBPACK FOOTER
// ../~/react-router/es/PropTypes.js
// module id = 208
// module chunks = 0